import type { SVGProps } from 'react'

interface TopographySatelliteIconProps extends SVGProps<SVGSVGElement> {}

export function TopographySatelliteIcon(props: TopographySatelliteIconProps) {
  return (
    <svg
      width={68}
      height={67}
      viewBox="0 0 68 67"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M36.949 31.531l-2.624 1.515 3.474 6.017 2.624-1.514-3.474-6.018zM34.193 33.122l-2.624 1.515 3.475 6.017 2.623-1.514-3.474-6.018zM31.44 34.705l-2.624 1.515 3.475 6.017 2.623-1.514-3.474-6.018zM28.683 36.293l-2.623 1.515 3.474 6.017 2.623-1.514-3.474-6.018zM25.93 37.89l-2.623 1.514 3.474 6.018 2.623-1.515-3.474-6.017zM38.71 33.136l-.622.359 1.202 2.082.622-.358-1.203-2.083zM43.18 60.337l.665-.073v4.285l-.399.226-.412-.578.146-3.86z"
        fill="currentColor"
      />
      <path
        d="M38.53 57.654l.399-.233 4.916 2.843-.399.226-2.259-.531-2.657-2.305z"
        fill="currentColor"
      />
      <path
        d="M43.446 60.49l-4.916-2.836v4.284l4.916 2.837V60.49zM43.18 55.84l.665-.08v4.285l-.399.233-.412-.578.146-3.86z"
        fill="currentColor"
      />
      <path
        d="M38.53 53.157l.399-.233 4.916 2.837-.399.232-2.259-.531-2.657-2.305z"
        fill="currentColor"
      />
      <path
        d="M43.446 55.993l-4.916-2.837v4.279l4.916 2.843v-4.285zM43.18 51.336l.665-.073v4.285l-.399.226-.412-.578.146-3.86z"
        fill="currentColor"
      />
      <path
        d="M38.53 48.653l.399-.233 4.916 2.843-.399.226-2.259-.531-2.657-2.305z"
        fill="currentColor"
      />
      <path
        d="M43.446 51.49l-4.916-2.837v4.284l4.916 2.837v-4.285zM43.18 46.839l.665-.08v4.285l-.399.232-.412-.578.146-3.859z"
        fill="currentColor"
      />
      <path
        d="M38.53 44.155l.399-.232 4.916 2.836-.399.233-2.259-.532-2.657-2.305z"
        fill="currentColor"
      />
      <path
        d="M43.446 46.992l-4.916-2.837v4.285l4.916 2.836v-4.284zM43.18 42.335l.665-.073v4.285l-.399.226-.412-.578.146-3.86z"
        fill="currentColor"
      />
      <path
        d="M38.53 39.652l.399-.226 4.916 2.836-.399.226-2.259-.531-2.657-2.305z"
        fill="currentColor"
      />
      <path
        d="M43.446 42.488l-4.916-2.836v4.284l4.916 2.837v-4.285z"
        fill="currentColor"
      />
      <path
        d="M42.237 40.322l-1.7-.983-.4.226 1.701 2 .399-.233v-1.01z"
        fill="currentColor"
      />
      <path
        d="M41.838 40.548l-1.7-.983v1.017l1.7.983v-1.017zM34.43 32.974l-2.623 1.515 3.474 6.018 2.623-1.515-3.474-6.018zM31.683 34.561l-2.623 1.515 3.474 6.017 2.623-1.514-3.474-6.018zM28.92 36.158l-2.623 1.515 3.474 6.018 2.623-1.515-3.474-6.018zM26.17 37.746l-2.623 1.515 3.475 6.017 2.623-1.515-3.475-6.017zM23.414 39.345l-2.623 1.515 3.474 6.017 2.624-1.514-3.475-6.018zM36.194 34.592l-.622.358 1.203 2.083.62-.359-1.201-2.082zM18.322 17.285l.266 5.826.399-.226v-5.68l-.665.08z"
        fill="currentColor"
      />
      <path
        d="M15.274 15.066l-.399.233 1.86 1.86 1.853.279.399-.233-3.713-2.139z"
        fill="currentColor"
      />
      <path
        d="M14.875 15.299v5.673l3.713 2.139v-5.673l-3.713-2.14zM22.223 19.537l.265 5.826.399-.226v-5.68l-.664.08z"
        fill="currentColor"
      />
      <path
        d="M19.173 17.318l-.399.226 1.854 1.86 1.86.286.398-.233-3.713-2.139z"
        fill="currentColor"
      />
      <path
        d="M18.774 17.544v5.68l3.714 2.139V19.69l-3.714-2.146zM26.122 21.789l.26 5.826.398-.233V21.71l-.658.08z"
        fill="currentColor"
      />
      <path
        d="M23.072 19.564l-.398.232 1.853 1.86 1.854.286.398-.233-3.707-2.145z"
        fill="currentColor"
      />
      <path
        d="M22.674 19.796v5.673l3.707 2.146v-5.673l-3.707-2.146zM30.02 24.034l.26 5.826.398-.226V23.96l-.658.073z"
        fill="currentColor"
      />
      <path
        d="M26.965 21.815l-.399.233 1.86 1.86 1.854.279.398-.226-3.713-2.146z"
        fill="currentColor"
      />
      <path
        d="M26.566 22.048l.007 5.673 3.707 2.139v-5.673l-3.714-2.14zM33.913 26.286l.266 5.826.398-.226v-5.68l-.664.08z"
        fill="currentColor"
      />
      <path
        d="M30.864 24.067l-.398.233 1.86 1.86 1.853.279.399-.233-3.714-2.139z"
        fill="currentColor"
      />
      <path
        d="M30.466 24.3v5.673l3.713 2.139v-5.673l-3.713-2.14zM34.578 28.066l-.398.226.877 2.471.398-.232v-1.96l-.877-.505z"
        fill="currentColor"
      />
      <path
        d="M34.18 28.292v1.966l.877.505v-1.96l-.877-.511zM31.25 40.88l.166 5.534 1.322 1.229 16.295-9.407v-5.672L31.25 40.88z"
        fill="currentColor"
      />
      <path
        d="M30.173 34.184l15.392-7.632 3.468 6.011-16.296 9.413-4.73-6.011 2.166-1.78z"
        fill="currentColor"
      />
      <path
        d="M42.233 32.418l-6.748 3.897 1.438 2.49 6.749-3.896-1.438-2.49zM40.65 23.722l-16.295 9.406.783 2.763 4.126.074 16.301-9.414-4.915-2.83z"
        fill="currentColor"
      />
      <path
        d="M29.263 35.964l-4.909-2.836-3.467 2.006V40.8l3.467 6.012 4.91 2.837 3.474-2.006v-5.667l-3.475-6.012zM25.523 3.853l-1.594.923 11.645 20.44 1.6-.923-11.651-20.44zM35.687 19.092l-.399.232.73 2.724 1.894 1.82.399-.233-2.624-4.543z"
        fill="currentColor"
      />
      <path
        d="M35.29 19.323l-3.476 2.005 2.624 4.545 3.475-2.005-2.623-4.545zM32.93 14.322l-.399.226.731 2.73 1.893 1.82.399-.232-2.624-4.544z"
        fill="currentColor"
      />
      <path
        d="M32.533 14.55l-3.474 2.006 2.623 4.545 3.475-2.006-2.624-4.545zM30.173 9.546l-.399.232.731 2.724 1.893 1.82.399-.233-2.624-4.543z"
        fill="currentColor"
      />
      <path
        d="M29.774 9.778l-3.475 2.006 2.624 4.545 3.475-2.006-2.624-4.545zM27.416 4.776l-.392.226.724 2.73 1.894 1.814.405-.226-2.63-4.544z"
        fill="currentColor"
      />
      <path
        d="M27.018 5.001l-3.475 2.006 2.624 4.545 3.475-2.006-2.624-4.545zM24.666 0l-.405.233.73 2.723 1.9 1.82.399-.232L24.666 0z"
        fill="currentColor"
      />
      <path
        d="M24.265.236L20.79 2.242l2.624 4.545 3.475-2.006L24.265.236zM37.175 24.293l-.399.233-.066.757.684.319.399-.233-.618-1.076z"
        fill="currentColor"
      />
      <path
        d="M36.779 24.52l-1.203.694.621 1.076 1.203-.694-.621-1.076zM42.237 25.608l-1.7-.983-.4.233 1.701 1.986.399-.226v-1.01z"
        fill="currentColor"
      />
      <path
        d="M41.838 25.834l-1.7-.976v1.01l1.7.976v-1.01zM43.18 22.326l.665-.08v4.286l-.399.232-.412-.585.146-3.852z"
        fill="currentColor"
      />
      <path
        d="M38.53 19.643l.399-.233 4.916 2.837-.399.232-2.259-.531-2.657-2.305z"
        fill="currentColor"
      />
      <path
        d="M43.446 22.48l-4.916-2.837v4.284l4.916 2.837v-4.285zM43.18 17.823l.665-.073v4.285l-.399.232-.412-.584.146-3.86z"
        fill="currentColor"
      />
      <path
        d="M38.53 15.14l.399-.233 4.916 2.843-.399.226-2.259-.532-2.657-2.305z"
        fill="currentColor"
      />
      <path
        d="M43.446 17.976l-4.916-2.837v4.285l4.916 2.843v-4.291zM43.18 13.326l.665-.08v4.284l-.399.233-.412-.578.146-3.86z"
        fill="currentColor"
      />
      <path
        d="M38.53 10.642l.399-.233 4.916 2.837-.399.232-2.259-.531-2.657-2.305z"
        fill="currentColor"
      />
      <path
        d="M43.446 13.478l-4.916-2.836v4.285l4.916 2.836v-4.285zM43.18 8.822l.665-.073v4.284l-.399.226-.412-.578.146-3.86z"
        fill="currentColor"
      />
      <path
        d="M38.53 6.138l.399-.232 4.916 2.843-.399.226-2.259-.532-2.657-2.305z"
        fill="currentColor"
      />
      <path
        d="M43.446 8.974L38.53 6.138v4.285l4.916 2.836V8.974zM43.18 4.325l.665-.08V8.53l-.399.232-.412-.578.146-3.86z"
        fill="currentColor"
      />
      <path
        d="M38.53 1.64l.399-.232 4.916 2.837-.399.232-2.259-.531L38.53 1.64z"
        fill="currentColor"
      />
      <path
        d="M43.446 4.477L38.53 1.641v4.284l4.916 2.837V4.477zM45.206 29.385l-.621.358 1.202 2.083.621-.358-1.202-2.083zM50.56 31.693l-3.474-6.018-.398.225 1.05 3.348 2.424 2.67.398-.225z"
        fill="currentColor"
      />
      <path
        d="M46.688 25.908l-2.623 1.514 3.474 6.018 2.623-1.515-3.474-6.017zM53.317 30.099l-3.474-6.019-.399.233 1.05 3.348 2.425 2.67.398-.232z"
        fill="currentColor"
      />
      <path
        d="M49.442 24.308l-2.623 1.515 3.477 6.016 2.623-1.515-3.477-6.017zM56.075 28.511L52.6 22.493l-.399.226 1.05 3.348 2.424 2.677.399-.233z"
        fill="currentColor"
      />
      <path
        d="M52.202 22.715L49.58 24.23l3.475 6.017 2.623-1.515-3.475-6.017zM58.83 26.917l-3.474-6.019-.399.233 1.05 3.348 2.424 2.67.399-.232z"
        fill="currentColor"
      />
      <path
        d="M54.96 21.13l-2.624 1.514 3.474 6.017 2.623-1.514-3.474-6.018zM61.588 25.33l-3.475-6.02-.398.227 1.05 3.348 2.424 2.67.399-.226z"
        fill="currentColor"
      />
      <path
        d="M57.712 19.533l-2.623 1.514 3.474 6.018 2.623-1.515-3.474-6.017zM46.793 40.96l-1.6.923 11.651 20.44 1.6-.923-11.65-20.44zM58.957 59.394l-.398.232.724 2.724 1.9 1.82.398-.233-2.624-4.543z"
        fill="currentColor"
      />
      <path
        d="M58.555 59.623l-3.474 2.007 2.626 4.544 3.474-2.008-2.626-4.543zM56.2 54.624l-.398.226.73 2.73 1.894 1.814.398-.226-2.624-4.544z"
        fill="currentColor"
      />
      <path
        d="M55.805 54.843L52.33 56.85l2.624 4.544 3.475-2.006-2.624-4.544zM53.444 49.848l-.4.233.732 2.723 1.893 1.82.398-.232-2.623-4.544z"
        fill="currentColor"
      />
      <path
        d="M53.044 50.077l-3.474 2.007 2.626 4.544 3.474-2.007-2.626-4.544zM50.686 45.079l-.399.225.73 2.73 1.894 1.814.399-.226-2.624-4.543z"
        fill="currentColor"
      />
      <path
        d="M50.29 45.301l-3.474 2.007 2.625 4.544 3.474-2.006-2.624-4.545zM47.93 40.302l-.399.233.731 2.723 1.893 1.82.405-.232-2.63-4.544z"
        fill="currentColor"
      />
      <path
        d="M47.536 40.53l-3.474 2.006 2.623 4.544 3.475-2.006-2.624-4.544z"
        fill="currentColor"
      />
      <path
        d="M46.176 39.884l-.399.232-.066.758.684.312.399-.226-.618-1.076z"
        fill="currentColor"
      />
      <path
        d="M45.785 40.114l-1.203.694.621 1.076 1.202-.694-.62-1.076zM47.319 35.42l-.4.232.878 2.465.398-.226v-1.96l-.877-.511z"
        fill="currentColor"
      />
      <path
        d="M46.92 35.652v1.96l.877.505v-1.96l-.877-.505zM51.245 36.29l.266 5.832.398-.232v-5.673l-.664.073z"
        fill="currentColor"
      />
      <path
        d="M48.195 34.071l-.398.233 1.853 1.86 1.86.279.399-.226-3.714-2.146z"
        fill="currentColor"
      />
      <path
        d="M47.797 34.304v5.673l3.713 2.145v-5.68l-3.713-2.138zM55.144 38.542l.259 5.826.398-.226v-5.68l-.657.08z"
        fill="currentColor"
      />
      <path
        d="M52.095 36.323l-.399.226 1.854 1.867 1.853.279.399-.233-3.707-2.139z"
        fill="currentColor"
      />
      <path
        d="M51.696 36.55v5.679l3.707 2.139v-5.673l-3.707-2.146zM59.043 40.794l.259 5.826.399-.233v-5.673l-.658.08z"
        fill="currentColor"
      />
      <path
        d="M55.987 38.575l-.398.226 1.86 1.86 1.853.286.399-.233-3.714-2.139z"
        fill="currentColor"
      />
      <path
        d="M55.589 38.801v5.68l3.713 2.139v-5.673L55.59 38.8zM62.942 43.046l.26 5.826.398-.233v-5.673l-.658.08z"
        fill="currentColor"
      />
      <path
        d="M59.887 40.82l-.399.233 1.854 1.86 1.86.286.398-.233-3.713-2.145z"
        fill="currentColor"
      />
      <path
        d="M59.488 41.053v5.673l3.714 2.146v-5.673l-3.714-2.146zM66.835 45.298l.266 5.826.398-.233v-5.673l-.664.08z"
        fill="currentColor"
      />
      <path
        d="M63.786 43.072l-.398.233 1.853 1.86 1.853.279.406-.226-3.714-2.146z"
        fill="currentColor"
      />
      <path
        d="M63.388 43.305v5.673l3.713 2.146-.007-5.68-3.706-2.14zM17.645 48.46l.126 4.145.99.923 12.21-7.048V42.23l-13.326 6.23z"
        fill="currentColor"
      />
      <path
        d="M16.835 43.444l11.538-5.72 2.598 4.505-12.21 7.054-3.547-4.51 1.62-1.329z"
        fill="currentColor"
      />
      <path
        d="M21.082 43.129l-3.164 1.827.674 1.167 3.164-1.826-.674-1.168zM20.964 45.714l-1.957 1.128.414.719 1.957-1.128-.414-.719zM24.693 35.6l-12.216 7.054.584 2.066 3.096.053 12.216-7.048-3.68-2.126zM12.477 42.654L9.88 44.155 6.943 49.47l2.332-.857 3.202-5.958zM16.157 55.03l-6.071-.12.864-1.382 5.453-.571 2.359.571-2.605 1.502z"
        fill="currentColor"
      />
      <path
        d="M11.388 54.16l7.373-.632v-4.245l-5.075 1.349-2.298 1.402v2.125z"
        fill="currentColor"
      />
      <path
        d="M18.761 49.283l-7.373 2.75-1.302-1.282-.512-1.534 6.583-4.444 2.604 4.51z"
        fill="currentColor"
      />
      <path
        d="M12.478 42.654l-4.232 6.065.704.896 1.136.167 6.072-5.01-3.68-2.118zM9.966 52.127l.06 2.072.498.459.863-.499v-2.125l-1.421.093z"
        fill="currentColor"
      />
      <path
        d="M9.56 49.616l.525.166 1.302 2.252-.863.498L8.75 50.28l.81-.664z"
        fill="currentColor"
      />
      <path
        d="M8.245 48.719l-.863.498.292 1.037 1.548.026.864-.498-1.84-1.063z"
        fill="currentColor"
      />
      <path
        d="M9.222 50.28l-1.84-1.063-1.302.75v2.127l1.302 2.252 1.84 1.062 1.302-.75v-2.126L9.222 50.28zM2.506 56.604l.153-.087v-.558h-.232l-.073.033.152.612z"
        fill="currentColor"
      />
      <path
        d="M1.981 55.474l.34-.1.338.585-.153.087-.172-.053-.2-.2-.153-.319z"
        fill="currentColor"
      />
      <path
        d="M1.69 55.182l.152-.086.479.279-.153.086h-.479v-.279z"
        fill="currentColor"
      />
      <path
        d="M1.35 55.933l.34.584.478.28.338-.193v-.558l-.338-.585-.479-.279-.338.2v.55zM4.486 59.706l-.265-.153 2.942-1.7.266.153-1.64 1.082-1.303.618z"
        fill="currentColor"
      />
      <path
        d="M4.486 59.706l-2.73-3.096-.313.087 2.73 3.075.253.226 3.003-1.734v-.259l-2.943 1.7z"
        fill="currentColor"
      />
      <path
        d="M1.284 56.584l.213-.12.259.147-.206.126h-.073l-.193-.153z"
        fill="currentColor"
      />
      <path
        d="M1.55 56.737l-.266-.153 2.877 3.262.265.152-2.876-3.261z"
        fill="currentColor"
      />
      <path
        d="M1.144 56.97l1.103-.639v-.305H2.12l-1.057.604.08.34z"
        fill="currentColor"
      />
      <path
        d="M1.875 55.754l.186-.06.186.332-1.103.631-.093-.026-.133-.273.957-.604z"
        fill="currentColor"
      />
      <path
        d="M.692 56.179l1.103-.638.266.153-1.103.637H.692v-.152z"
        fill="currentColor"
      />
      <path
        d="M.5 56.597l.193.326.265.152.186-.106v-.312l-.186-.325-.265-.153-.193.113v.305zM9.389 53.156l.12 4.139.989.916.877-.504v-4.239l-1.986-.312z"
        fill="currentColor"
      />
      <path
        d="M7.734 48.639l1.043.339 2.598 4.49-.877.505-3.534-4.49.77-.844z"
        fill="currentColor"
      />
      <path
        d="M5.11 46.859l-.877.498.585 2.066 3.082.06.877-.505-3.667-2.12z"
        fill="currentColor"
      />
      <path
        d="M7.9 49.483l-3.667-2.126-2.597 1.501v4.238l2.597 4.491L7.9 59.713l2.597-1.502v-4.238L7.9 49.483z"
        fill="currentColor"
      />
      <path
        d="M6.38 53.714l.033.963.226.213.465-.266v-.99l-.724.08z"
        fill="currentColor"
      />
      <path
        d="M5.994 52.658l.498-.073.611 1.05-.465.272-.824-1.05.18-.2z"
        fill="currentColor"
      />
      <path
        d="M5.635 52.093l-.458.266.14.485.717.013.458-.272-.857-.492z"
        fill="currentColor"
      />
      <path
        d="M6.034 52.857l-.857-.498-.605.352v.99l.605 1.05.857.49.604-.351v-.983l-.604-1.05z"
        fill="currentColor"
      />
    </svg>
  )
}
